import clsx from 'clsx';

import DrupalImage from '@commons/components/Image/Drupal';
import { breakpoints } from '@commons/contexts/responsive';
import type { DrupalBlock, DrupalImage as DrupalImageType } from '@commons/types/drupal';

import styles from './FeaturedImage.module.scss';

/**
 * Next.js Image `sizes` property for the InsightFeaturedImage block component.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

const IMAGE_SIZES = `(max-width: ${breakpoints.lg}px) 100vw, (max-width: ${breakpoints.xl}px) 630px, 860px`;

/**
 * InsightFeaturedImage field block.
 */

const InsightFeaturedImageBlock = ({ content }: DrupalBlock<DrupalImageType>) => {
  if (!content) return null;

  const classes = clsx(styles.featuredImage, 'w-100');

  return <DrupalImage {...content} sizes={IMAGE_SIZES} className={classes} />;
};

export default InsightFeaturedImageBlock;
